import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import cx from 'classnames'
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper'
import style from './StaticMap.less'

const ABC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export function circlePath(center, radius) {
    const googleCenter = new google.maps.LatLng(center)
    
    var path = []
    for (var i = 0 ; i < 360 ; i += 8) {
        const latLng = google.maps.geometry.spherical.computeOffset(googleCenter, radius, i)
        path.push(latLng)
    }
    return path
}

function markerLatLng(latLng) {
    return latLng.lat + ',' + latLng.lng
}

function displayAddress(address) {
    return (
        <div>
            {address.quality && (
                <p>
                    <span>{address.quality}</span>
                </p>
            )}
            <p>
                <span>{address.number}</span>
                <span> {address.street}</span>
            </p>
            <p>
                <span>{address.zipCode}</span>
                <span> {address.city}</span>
            </p>
        </div>
    )
}

class StaticMap extends Component {
    static propTypes = {
        apiKey: PropTypes.string,
        ratio: PropTypes.number,
        info: PropTypes.bool,
        path: PropTypes.array,
        identify: PropTypes.func,
        display: PropTypes.func,
        value: PropTypes.array.isRequired
    }

    static defaultProps = {
        identify: (v) => v,
        display: displayAddress
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentDidMount() {
        const {apiKey, path, identify, value} = this.props

        const src = this._imageSrc(findDOMNode(this), apiKey, path, identify, value)
        this.setState({src})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value
            || nextProps.path != this.props.path) {
            const {apiKey, path, identify, value} = nextProps

            clearTimeout(this._timer)
            this._timer = setTimeout(() => {
                // wait for element to get his size
                const src = this._imageSrc(findDOMNode(this), apiKey, path, identify, value)
                this.setState({src})
            }, 0)
        }
    }

    componentWillUnmount() {
        clearTimeout(this._timer)
    }

    _imageSrc(element, apiKey, path, identify, value) {
        if (element.offsetWidth && element.offsetHeight) {
            const options = {
                key: apiKey,
                size: element.offsetWidth + 'x' + element.offsetHeight,
            }

            if (path) {
                options.path = 'fillcolor:0xAA000033|color:0xFFFFFF00|enc:' + google.maps.geometry.encoding.encodePath(path)
            }

            options.markers = value.map((v, i) => {
                const latLng = identify(v)
                return latLng && ('label:' + ABC.charAt(i) + '|' + markerLatLng(latLng))
            })

            var query = Object.keys(options).filter((k) => options[k]).map((key) => {
                const option = options[key]

                if (option instanceof Array) {
                    return option.filter((o) => o).map((v) => key + '=' + encodeURIComponent(v)).join('&')
                }
                return key + '=' + encodeURIComponent(option)
            })

            const queryString = query.join('&')
            const src = 'https://maps.googleapis.com/maps/api/staticmap?' + queryString
            return src
        }
        return null
    }

    _toggle() {
        const {opened} = this.state
        this.setState({opened: !opened})
    }

    _close() {
        this.setState({opened: false})
    }

    render() {
        const {ratio, info, display, value} = this.props
        const {src, opened} = this.state

        const defaultStyle = {
            paddingBottom: ratio && (100 / ratio + '%') || '100%'
        }

        return (
            <div
                className={cx(style.default, {[style.clickable]: info})}
                style={defaultStyle}
                onClick={() => this._toggle()}>
                {src && (
                    <img src={src} />
                )}
                {opened && info && (
                    <RootCloseWrapper noWrap
                        onRootClose={() => this._close()}>
                        <div className={style.info}>
                            <ul className={style.infoContent}>
                                {value.map((item, index) => (
                                    <li key={index}>
                                        <div className={style.label}>{ABC.charAt(index)}</div>
                                        <div className={style.container}>{display(item)}</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </RootCloseWrapper>
                )}
            </div>
        )
    }
}

export default StaticMap


// WEBPACK FOOTER //
// ./lib/core/components/StaticMap.js